import { useCallback } from "react";
import axios from "axios";
import { useAuthProfile } from "../utils/useAuthProfile";
import { useSafeAuth0 } from "./useSafeAuth0";
import SessionTimeoutManager from "../utils/SessionTimeoutManager";

export const useLogout = (): ((preserveState?: boolean) => Promise<void>) => {
  const [, , handleLogout] = useAuthProfile();

  const { logout: auth0Logout, isAuthenticated: isAuth0Authenticated } =
    useSafeAuth0();

  return useCallback(
    async (preserveState = false): Promise<void> => {
      try {
        await axios.get("/auth/logout/");
      } catch (e) {
        // Ignore logout errors - proceed with client-side logout
      }

      SessionTimeoutManager.clear();

      handleLogout(preserveState);

      if (isAuth0Authenticated && auth0Logout) {
        auth0Logout({
          logoutParams: {
            returnTo: `${globalThis.location.origin}/login`,
          },
        });
      }
    },
    [handleLogout, auth0Logout, isAuth0Authenticated]
  );
};
